import React from 'react';
import { LoginPage } from '../../pages/Login/LoginPage';
import { AuthCallbacks } from '../../auth/Auth';

interface Props {
  auth: AuthCallbacks;
}

export const UnauthenticatedArea: React.VFC<Props> = ({ auth }) => {
  return <LoginPage auth={auth} />;
};
